import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Statistic, Typography, Spin } from 'antd';
import { UserOutlined, SafetyCertificateOutlined, DollarOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import API from '../api';

export default function Dashboard() {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/dashboard').then(r => setStats(r.data)).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading || !stats) return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;

  const bookingData = [
    { name: 'Active', value: stats.activeBookings, color: '#3b82f6' },
    { name: 'Pending', value: stats.pendingBookings, color: '#f59e0b' },
    { name: 'Completed', value: stats.completedBookings, color: '#16a34a' },
    { name: 'Cancelled', value: stats.cancelledBookings, color: '#ef4444' },
  ].filter(d => d.value > 0);

  return (
    <div style={{ padding: 24 }}>
      <Typography.Title level={4} style={{ marginBottom: 24 }}>Platform Overview</Typography.Title>

      <Row gutter={[16, 16]}>
        <Col xs={12} sm={6}><Card><Statistic title="Total Users" value={stats.totalUsers} prefix={<UserOutlined />} /></Card></Col>
        <Col xs={12} sm={6}><Card><Statistic title="Customers" value={stats.totalCustomers} valueStyle={{ color: '#3b82f6' }} /></Card></Col>
        <Col xs={12} sm={6}><Card><Statistic title="Providers" value={stats.totalProviders} valueStyle={{ color: '#7c3aed' }} /></Card></Col>
        <Col xs={12} sm={6}><Card><Statistic title="Verified" value={stats.verifiedProviders} valueStyle={{ color: '#16a34a' }} prefix={<SafetyCertificateOutlined />} /></Card></Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={12} sm={6}><Card><Statistic title="Active Jobs" value={stats.activeBookings} valueStyle={{ color: '#3b82f6' }} /></Card></Col>
        <Col xs={12} sm={6}><Card><Statistic title="Pending" value={stats.pendingBookings} valueStyle={{ color: '#f59e0b' }} /></Card></Col>
        <Col xs={12} sm={6}><Card><Statistic title="Gross Revenue" value={stats.grossRevenue} prefix="R" precision={0} valueStyle={{ color: '#16a34a' }} /></Card></Col>
        <Col xs={12} sm={6}><Card><Statistic title="Commission" value={stats.platformCommission} prefix="R" precision={0} valueStyle={{ color: '#1e40af' }} /></Card></Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} sm={12}>
          <Card title="Booking Breakdown">
            {bookingData.length > 0 ? (
              <ResponsiveContainer width="100%" height={250}>
                <PieChart>
                  <Pie data={bookingData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label={({ name, value }) => `${name}: ${value}`}>
                    {bookingData.map((d, i) => <Cell key={i} fill={d.color} />)}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            ) : <Typography.Text type="secondary">No bookings yet</Typography.Text>}
          </Card>
        </Col>
        <Col xs={24} sm={12}>
          <Card title="Quick Stats">
            <Statistic title="Categories" value={stats.totalCategories} style={{ marginBottom: 16 }} />
            <Statistic title="Unverified Providers" value={stats.unverifiedProviders} valueStyle={{ color: stats.unverifiedProviders > 0 ? '#ef4444' : '#16a34a' }} />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
